const depositHelpers = {

	depositAmountList(depositData){
		let amount = 0;
		depositData.forEach(details => {
			details.description.forEach(total => {
				amount +=  parseFloat(total.current_balance);
			})
		})

		console.log(amount);

		return amount;
	},
	sleep(milliseconds) {
		const date = Date.now();
		let currentDate = null;
		do {
			currentDate = Date.now();
		} while (currentDate - date < milliseconds);
	}

}

export default depositHelpers;